/**
 * Chinese translations for summary analysis
 */
const summary = {
    summary: {
      title: "性格概述",
      demoData: "演示数据",
      noData: "暂无可用的概述分析数据",
      stars: {
        "紫微": "你天生有王者气场，骨子里就是要带头的人。你的人设不适合服从太久，你适合创造方向、设定标准。越早意识到\"我不是来被指挥的\"，你会越早翻盘。",
        "天府": "你天生稳重、可靠，擅长管理和规划。你对资源的掌控能力强，适合担任管理和协调的角色。越早意识到\"稳定是你的优势\"，你会越早建立自己的王国。",
        "天相": "你天生温和、善于协调，擅长处理人际关系。你适合担任协调和管理的角色，建立和谐的团队氛围。越早意识到\"协调是你的天赋\"，你会越早发挥自己的影响力。",
        "武曲": "你是天生的执行者，行得快、撑得久、做得深。你对时间、效率、成果特别有意识。你不是花拳绣腿型，你是靠干、靠拼、靠狠劲活出价值的人。",
        "天机": "你是天生的思考者，反应快、洞察力强。你不喜欢被困在规则里，擅长快速抓取变化与机会。唯有行动才能让你的聪明兑现成成果，别让犹豫成为束缚。",
        "文曲": "你是艺术气质型人格，情感丰富、审美力强、感受力极高。你很会感人，也常常容易\"被情绪影响\"。你适合传达美、传递氛围、写下感觉。",
        "文昌": "你是理性派的表达者，思路清晰，逻辑严谨，适合教学、研究、写作等需要组织性强的领域。你的优势在于\"讲得懂＋写得清\"，别人绕圈时，你能一语道破。",
        "贪狼": "你是命盘里\"最懂得玩\"的人。你多才多艺、多变多面，吸引力强，有创造力与极高的人际磁场。",
        "太阳": "你是来发光的。你身上有一种天生的温暖、领导气场与承担力。别人犹豫时，你已经点燃自己照亮别人。",
        "太阴": "你是安静的力量，是默默观察、稳定输出、从细节中见深度的人。你拥有强大的情感洞察力，是天生的倾听者与照顾者。",
        "巨门": "你是思辨型人格，常常一语戳破重点，带有强烈的洞察与\"敢说真话\"的气场。你的话术强、逻辑力高，是打破假象的人。",
        "天同": "你是\"世界的疗愈剂\"，内在柔软、有同理心，喜欢和善、讨厌冲突，是温柔但坚定的理想主义者。你渴望世界更好，而你也会用行动慢慢修补它。",
        "七杀": "你是天生的突破者、不走寻常路的先锋军。你天生带着\"不爽就改、不对就拆\"的霸气，别人犹豫的时候你已经冲上战场。",
        "破军": "你是不断打破自己、再重建自己的灵魂型人格。你活得不轻松，但每一次转弯都比别人精彩十倍。你不怕输，你怕一成不变。",
        "左輔": "你天生给人安全感，是团队中最可靠的存在。你擅长倾听、扶持、补位，是领导信赖的左膀右臂。",
        "右弼": "你为人亲切、擅长调和人际关系，是让团队更和谐的粘合剂。",
        "天梁": "你天生有责任感，具有公理与同理心，是团队中守护者的角色，擅长安抚与解决冲突。",
        "廉贞": "你充满斗志、外冷内热，是带点叛逆的领袖人格。擅长突破框架，挑战权威。"
      }
    }
  
};

export default summary; 